module.exports = __webpack_public_path__ + "media/images/result_sets/circles/2r3n4n8n-cc7712f5c4879aebc0c57db5ac4945e5.svg";